"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSelector = void 0;
// eslint-disable-next-line import/prefer-default-export
var organization_selector_component_1 = require("./organization-selector.component");
Object.defineProperty(exports, "OrganizationSelector", { enumerable: true, get: function () { return organization_selector_component_1.OrganizationSelector; } });
